/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Aoun.Api
 * OpenAPI spec version: 1.0
 */

export type SubMissionKind = typeof SubMissionKind[keyof typeof SubMissionKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubMissionKind = {
  Hajj: 'Hajj',
  Umrah: 'Umrah',
  Exhibition: 'Exhibition',
  SocialEvent: 'SocialEvent',
  Lecture: 'Lecture',
  Other: 'Other',
} as const;
